import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbf6deec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-toolbar" }
const _hoisted_2 = { class: "map-toolbar__title" }
const _hoisted_3 = { class: "map-toolbar__label" }
const _hoisted_4 = {
  key: 0,
  class: "map-toolbar__count"
}
const _hoisted_5 = { class: "map-toolbar__actions" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-crosshair" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["title"]

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapToolbar',
  props: {
    mode: {},
    markerCount: {},
    enableFullscreen: { type: Boolean },
    isFullscreen: { type: Boolean }
  },
  emits: ["reset-view", "toggle-fullscreen"],
  setup(__props: any) {

const props = __props;



const modeLabel = computed(() =>
  props.mode === 'warehouses' ? 'Kho / địa điểm' : 'Đơn vị toàn quốc'
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(modeLabel.value), 1),
      (_ctx.markerCount != null)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.markerCount) + " điểm ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-icon btn-light",
        title: "Về vị trí mặc định",
        "aria-label": "Về vị trí mặc định",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reset-view')))
      }, _hoisted_7),
      (_ctx.enableFullscreen)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-sm btn-icon btn-light",
            title: _ctx.isFullscreen ? 'Thu nhỏ' : 'Toàn màn hình',
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-fullscreen')))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(
            _ctx.isFullscreen ? 'bi bi-fullscreen-exit' : 'bi bi-arrows-fullscreen'
          )
            }, null, 2)
          ], 8, _hoisted_8))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})